<template>
  <div>
    <SummaryTitle title="Candidate"></SummaryTitle>
    <SummaryItem itemTitle="Candidate Name" v-if="!!firstName && !!lastName">
      <template v-slot:content>
        {{ candidateName }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Email">
      <template v-slot:content>
        {{ !!emailAddress ? emailAddress : 'Missing' }}
      </template>
    </SummaryItem>
  </div>
</template>
<script>
import { SummaryTitle, SummaryItem } from '@/components/shared/display'

export default {
  components: {
    SummaryTitle,
    SummaryItem
  },
  props: ['firstName', 'lastName', 'emailAddress'],
  computed: {
    candidateName () {
      return `${this.firstName ? this.firstName + ' ' : 'Missing First Name'} ${this.lastName ? this.lastName : 'Missing Last Name'}`
    }
  }
}
</script>
